export const initialState = {
    term: null,
};

const reducer = (state, action) => {
    console.log("action ------- ", action);
    console.log("state ------- ", state);

    // action -> type, [payload]

    switch (action.type) {
        case "SET_SEARCH_TERM":
            console.log("---- This is case--- ");
            return {
                ...state,
                term: action.term,
            };

        default:
            console.log("---- This is default--- ");
            return state;
    }
};

export default reducer;